// extracted by mini-css-extract-plugin
export default {"title":"SubPageTemplate_title__gNv1-","titleBackground":"SubPageTemplate_titleBackground__wAQ-u"};